import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconBold = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      transform="translate(-5.803 -4.1)"
      fill={props.color}
      d="M9.30945 17V7.20001H14.0974C15.3294 7.20001 16.2534 7.43335 16.8694 7.90001C17.4948 8.36668 17.8074 8.98268 17.8074 9.74801C17.8074 10.2613 17.6814 10.7093 17.4294 11.092C17.1774 11.4653 16.8321 11.7547 16.3934 11.96C15.9548 12.1653 15.4508 12.268 14.8814 12.268L15.1474 11.694C15.7634 11.694 16.3094 11.7967 16.7854 12.002C17.2614 12.198 17.6301 12.492 17.8914 12.884C18.1621 13.276 18.2974 13.7567 18.2974 14.326C18.2974 15.166 17.9661 15.824 17.3034 16.3C16.6408 16.7667 15.6654 17 14.3774 17H9.30945ZM11.5634 15.292H14.2094C14.7974 15.292 15.2408 15.1987 15.5394 15.012C15.8474 14.816 16.0014 14.508 16.0014 14.088C16.0014 13.6773 15.8474 13.374 15.5394 13.178C15.2408 12.9727 14.7974 12.87 14.2094 12.87H11.3954V11.218H13.8174C14.3681 11.218 14.7881 11.1247 15.0774 10.938C15.3761 10.742 15.5254 10.448 15.5254 10.056C15.5254 9.67335 15.3761 9.38868 15.0774 9.20201C14.7881 9.00601 14.3681 8.90801 13.8174 8.90801H11.5634V15.292Z"
    />
  </svg>
)

export default IconBold
